export default __webpack_public_path__ + "static/media/V545_SOV.affca852.pdf";